enum LogAction {
    Create = 'create',
    Resend = 'resend',
}

enum LogStatus {
    Success = 0,
    Error = 1,
}

export class BilletLogModel {
    id: string = '';
    date: string = '';
    action: LogAction = LogAction.Create;
    status: LogStatus = LogStatus.Success;
    data: any = null;
    user: any = null;

    constructor(b?:Partial<BilletLogModel>) {
        Object.assign(this, b)
    }

    getDescription():string {
        switch (this.status) {
            case LogStatus.Success:
                if (this.action === LogAction.Create) {
                    return `Boleto criado com sucesso.`
                }

                if (this.action === LogAction.Resend) {
                    if (!this.user) {
                        return `Boleto reenviado com sucesso.`
                    }

                    return `Boleto reenviado com sucesso. Feito pelo usuário ${this.user.username}.`
                }

                return `Sucesso ao processar a ação ${this.action}.`

            case 1:
                if (this.action === LogAction.Create) {
                    return `Houve um erro no momento de criar o boleto.`
                }

                if (this.action === LogAction.Resend) {
                    if (!this.user) {
                        return `Houve um erro no momento de reenviar o boleto.`
                    }

                    return `Houve um erro no momento de reenviar o boleto. Iniciado pelo usuário ${this.user.username}.`
                }

                return `Erro ao processar a ação ${this.action}.`

            default: 
                return '';
        }
    }
}

